var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var PathSegmentModel = require("./pathSegmentModel");
var TangentHandleModel = require("./tangentHandleModel");

var PathBezierSegmentModel = function (pathInteractionModel, object, next_handle, prev_handle) {
    PathSegmentModel.apply(this, arguments);

    this.tan_0 = this.value("tan_0", true);
    this.tan_1 = this.value("tan_1", true);

    this.tan_0(new TangentHandleModel(this, this.prev_handle, this.object.tan_0, false));
    this.tan_1(new TangentHandleModel(this, this.next_handle, this.object.tan_1, false));
};
lib_core.inherit(PathBezierSegmentModel, PathSegmentModel);
PathBezierSegmentModel.$class = "PathBezierSegmentModel";
module.exports = PathBezierSegmentModel;

PathBezierSegmentModel.prototype.initialize = function() {
    PathSegmentModel.prototype.initialize.call(this);

    var prev_seg = this.prev_handle.prev_segment;
    if(prev_seg && prev_seg.object.type() == cio_datamodel.PathType.CURVEC) {
        prev_seg.tan_1().neighbourSegmentModel(this);
        prev_seg.tan_1().neighbourTangentHandleModel(this.tan_0());
        this.tan_0().neighbourSegmentModel(prev_seg);
        this.tan_0().neighbourTangentHandleModel(prev_seg.tan_1());
    }
};

PathBezierSegmentModel.prototype.getInspectorElements = function () {
    var self = this;

    var inspectorElements = PathSegmentModel.prototype.getInspectorElements.call(this);

    inspectorElements.help_elements = {
        'name': 'Bezier Segment'
    };

    return inspectorElements;
};

PathBezierSegmentModel.prototype.afterMoveStartPoint = function(vec) {
    this.object.tan_0(this.object.tan_0().add(vec));
};

PathBezierSegmentModel.prototype.afterMoveEndPoint = function(vec) {
    this.object.tan_1(this.object.tan_1().add(vec));
};

PathBezierSegmentModel.prototype.createPathObjectOnSegment = function(coord) {
    var prev_endpoint = this.prev_handle.coord();
    var next_endpoint = this.next_handle.coord();

    var new_object = new cio_datamodel.PathObjectData(coord.copy(), cio_datamodel.PathType.CURVEC);
    new_object.tan_0(this.object.tan_0());

    var dir = next_endpoint.sub(prev_endpoint).norm();
    var length_new = coord.distance(prev_endpoint);
    var length_old = coord.distance(next_endpoint);
    new_object.tan_1(coord.add(dir.mult(-length_new*1/4)));
    this.object.tan_0(coord.add(dir.mult(length_old*1/4)));

    return new_object;
};